module.exports = __webpack_public_path__ + "img/collection.02b10133.png";